const attributionFields = {
  utm_campaign: 'campaign_name',
  utm_content: 'campaign_content',
  utm_medium: 'campaign_medium',
  utm_source: 'campaign_source',
  utm_term: 'campaign_term',
}

export default attributionFields
